import { GET_BUSINESS_LIST_API } from '../constants/AppConstants';

/**
 * Service to get the business segment list from the API.
 */
const getBusinessSegments = async (industryId) => {
  try {
    const response = await fetch(GET_BUSINESS_LIST_API.replace('$industryId$', industryId), {
      method: 'GET',
    });

    let json = [];
    if (response.status !== 204) {
      json = await response.json();
    }

    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};

export default getBusinessSegments;
